export const version = 'v5.9.0';
export const buildDate = '2026-10-14T00:49:19.525Z';
export const commitHash = 'eed914e';